export default __webpack_public_path__ + "static/media/image.creed-solution.9ed68d78.png";